import { twMerge } from 'tailwind-merge';
import { CallRecordKey, QueueKey } from 'flow/types/EntityKeys';
import useAppContext from 'flow/hooks/useAppContext';
import { useCallRecordWithCtiContactByKey } from 'flow/hooks/useCallRecordWithCtiContact';
import { isCallRecordAMeeting } from 'flow/utils/call-records-utils';
import { PageType } from 'flow/components/call-history-v2/types';
import CallRecordDetails from './CallRecordDetails';
import ContactSubtitle from './ContactSubtitle';

interface Props {
    callRecordKey: CallRecordKey;
    contactFullName?: string;
    queueKeyContext?: QueueKey;
    compact?: boolean;
    pageType: PageType;
}

const DetailSection = ({
    callRecordKey,
    contactFullName,
    queueKeyContext,
    compact,
    pageType,
}: Props) => {
    const { i18next } = useAppContext();
    const callRecord = useCallRecordWithCtiContactByKey(callRecordKey);

    if (!callRecord) return null;

    const isVideoCall = isCallRecordAMeeting(callRecord);

    return (
        <>
            <div
                className={twMerge(
                    'text-sm leading-6 text-gray-500 antialiased',
                    compact ? 'truncate' : 'break-words',
                )}
            >
                {isVideoCall ? (
                    i18next.t('Call.VideoMeeting')
                ) : (
                    <ContactSubtitle
                        contact={callRecord.get('contact')}
                        contactFullName={contactFullName}
                        number={callRecord.get('number')}
                    />
                )}
            </div>

            <CallRecordDetails
                callRecordKey={callRecordKey}
                queueKeyContext={queueKeyContext}
                compact={compact}
                pageType={pageType}
            />

            {
                // TO DO: Re-add open ticket button when we have ticket data for the call record
                /*<div className="absolute end-0 bottom-0">
            <OpenTicketItem ticketKey={callRecord.get('omniTicketEntityKey')} />
        </div>*/
            }
        </>
    );
};

export default DetailSection;
